import { Main, LoadSection, MassiveProductList } from "./styles";

import LoadingIcon from "../../assets/loading.gif";
import EmptyIcon from "../../assets/Icons/caja-vacia.png";

import { useEffect, useState } from "react";
import { useProducts } from "../../stores/useProducts";
import { HeaderOptions } from "./components/HeaderOptions/HeaderOptions";

import { ProductCard } from "./components/ProductCard/productCard";

import { PreviousView } from "./components/PreviousView/PreviousView";
import { readXlsxFile } from "./utils/read-excel";
import { parseArticles } from "./utils/parse-articles";
import useNotifications from "../../hooks/useNotification";
import CustomNotification from "../general/CustomNotification";
import { SaveBulkProducts } from "../../services/massive-upload/massive-upload.service";

const MassiveUploadPage = () => {
  const [loading, setLoading] = useState(true);
  // const [massiveProducts1, setMassiveProducts] = useState([]);

  const [allChecked, setAllChecked] = useState(false);

  const [productsChecked, setProductsChecked] = useState({});
  const [categoriesSelected, setCategoriesSelected] = useState([]);

  const [draggableActive, setDraggableActive] = useState(false);
  const [previousViewActive, setPreviousViewActive] = useState(false);

  const [xlsFile, setXlsFile] = useState(null);
  const [xlsRows, setxlsRows] = useState([]);
  const [categoryNameXls, setCategoryNameXls] = useState("");
  const [loadingXls, setLoadingXls] = useState(false);

  const { notifications, addNotification, deleteNotification } =
    useNotifications();

  const { products, massiveProducts, setMassiveProducts, initializeProducts } = useProducts();

  function renderProductsGrid() {
    return massiveProducts.map((product) => (
      <ProductCard
        key={product?.article?.upc}
        upc={product?.article?.upc}
        company_id={product?.article?.company_id}
        company_name={product?.article?.company_name}
        product_name={product?.article?.name}
        general_percentage={product.percentage}
        image_url={product?.src}
        category_id={product?.article?.id_category}
        category_name={product?.article?.category}
        is_visible={product.is_visible}
        retailers={product.retailers}
        checked={!!productsChecked[product?.article?.upc]?.checked}
        onCheckboxChange={(data) => {
          setProductsChecked((prevState) => ({
            ...prevState,
            [data.upc]: data,
          }));
        }}
      />
    ));
  }

  async function saveArticlesData({ articles = [] }) {
    const { data: articlesParsed, error: errorArticlesParsed } = parseArticles({
      articles,
    });

    if (errorArticlesParsed)
      return addNotification("error", errorArticlesParsed, 6000);

    if (!Array.isArray(articlesParsed) || articlesParsed.length === 0)
      return addNotification(
        "error",
        "Error: No se encontraron productos para guardar",
        6000
      );

    const { error: errorSaveBulkProducts } = await SaveBulkProducts({
      products: articlesParsed,
    });

    if (errorSaveBulkProducts) addNotification("error", errorSaveBulkProducts, 6000);
    else addNotification("success", "Datos guardados correctamente!", 6000);

    setPreviousViewActive(false);
    setLoading(true);
    await initializeProducts();
  }

  useEffect(() => {
    initializeProducts();
  }, []);

  useEffect(() => {
    const massiveProducts = products.filter(
      (product) => (product?.stage === null && product.percentage <= 17)
    );

    setMassiveProducts(massiveProducts);

    if (massiveProducts.length > 0) setLoading(false);
  }, [products]);

  useEffect(() => {
    if (categoriesSelected.length === 0)
      return setMassiveProducts(
        products.filter((product) => (product?.stage === null && product.percentage <= 17)
        )
      );

    setMassiveProducts(
      products.filter((product) => {
        return (
          (product?.stage === null && product.percentage <= 17) &&
          categoriesSelected.includes(product.article.id_category)
        );
      })
    );
  }, [categoriesSelected]);

  useEffect(() => {
    const productsCheckedCount = Object.values(productsChecked).filter(
      (product) => product.checked
    ).length;

    if (productsCheckedCount === massiveProducts.length) setAllChecked(true);

    if (productsCheckedCount === 0) setAllChecked(false);
  }, [productsChecked, massiveProducts]);

  useEffect(() => {
    const productsCheckedCount = Object.values(productsChecked).filter(
      (product) => product.checked
    ).length;

    if (productsCheckedCount.length === 0) return;

    setProductsChecked((prevState) => {
      const newState = { ...prevState };

      // Remove unchecked products that are not in the current massiveProducts list
      Object.keys(newState).forEach((upc) => {
        if (!massiveProducts.find((product) => product.article.upc === upc)) {
          delete newState[upc];
        }
      });

      return newState;
    });
  }, [massiveProducts]);

  useEffect(() => {
    if (allChecked) {
      const newProductsChecked = {};
      massiveProducts.forEach((product) => {
        newProductsChecked[product?.article?.upc] = {
          upc: product?.article?.upc,
          company_id: product?.article?.company_id,
          category_id: product?.article?.id_category,
          retailers: product.retailers,
          is_visible: product.is_visible,
          checked: true,
        };
      });
      setProductsChecked(newProductsChecked);
    } else {
      setProductsChecked({});
    }
  }, [allChecked]);

  useEffect(() => {
    // console.log({xlsFile})

    const loadExcelFile = async () => {
      if (!xlsFile) return;

      const response = await readXlsxFile({ xlsxFile: xlsFile });

      if (response.error) {
        console.error("Error reading Excel file:", response.error);
        setLoadingXls(false);
        return;
      }

      if (response.data.rows.length > 0) setPreviousViewActive(true);

      setxlsRows(response.data.rows || []);
      setCategoryNameXls(response.data.filename);
      setXlsFile(null);
    };

    loadExcelFile();
  }, [xlsFile]);

  useEffect(() => {
    if (previousViewActive) return;

    setxlsRows([]);
    setXlsFile(null);
  }, [previousViewActive]);

  return (
    <Main>
      <HeaderOptions
        setCategoriesSelected={setCategoriesSelected}
        productsChecked={productsChecked}
        allChecked={allChecked}
        setAllChecked={setAllChecked}
        setPreviousViewActive={setPreviousViewActive}
        setXlsFile={setXlsFile}
        addNotification={addNotification}
      />

      {loading ? (
        <LoadSection>
          <img src={LoadingIcon} alt="Loading..." />
          <p>Cargando lista de productos...</p>
        </LoadSection>
      ) : massiveProducts.length > 0 ? (
        <MassiveProductList>{renderProductsGrid()}</MassiveProductList>
      ) : (
        <LoadSection>
          <img src={EmptyIcon} alt="Sin artículos" />
          <p>No hay productos disponibles</p>
        </LoadSection>
      )}

      <PreviousView
        categoryName={categoryNameXls}
        previousViewActive={previousViewActive}
        setPreviousViewActive={setPreviousViewActive}
        xlsRows={xlsRows}
        loadingXls={loadingXls}
        saveArticlesData={saveArticlesData}
        rowsDataPositions={{
          headers: 0,
          headersIds: 1,
          isDescription: 2,
          obligatories: 3,
          headerType: 6,
          values: 9,
        }}
      />

      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
    </Main>
  );
};

export default MassiveUploadPage;
